import axios from "./axios";

export const sendMessage = (email: string, message: string) => {
  return axios.post("support/contact", { email, message });
};

export const sendCallback = (phone: string) => {
  return axios.post("support/callback", { phone });
};
